export const formDataHelper = (file: File) => {
  const data = new FormData();
  data.append('file', file);
  return data;
};
